import React from 'react';
import s from './style.module.css';

import ContactInput from '../../components/contactinput';
import ContactTextarea from '../../components/contacttextarea';
import Checkbox from '../../components/checkbox';

import useForm from "./useForm";
import { validate } from './formValidationRules';

const Form = (props) => {
	const { handleChange, handleClick, errors, fields} = useForm(valid, validate, props);

	function valid(fields, valid) {
		props.onSubmitValues(fields, valid)
	}

	return (
		<form>
			<div className={s.inputWrapper}>
				<ContactInput type={fields['firstname'].type} error={fields['firstname'].error} name="firstname" onChange={handleChange} value={fields['firstname'].value || ''} labelText="First name" required={fields['firstname'].required}/>
				<ContactInput type={fields['lastname'].type}  error={fields['lastname'].error} name="lastname" onChange={handleChange} value={fields['lastname'].value || ''} labelText="Last name" required={fields['lastname'].required}/>
			</div>
			<ContactInput type={fields['email'].type} error={fields['email'].error} name="email" onChange={handleChange} value={fields['email'].value || ''} labelText="Email" required={fields['email'].required} />
			<ContactInput type={fields['phone'].type} name="phone" error={fields['phone'].error} onChange={handleChange} value={fields['phone'].value || ''} labelText="Phone number" required={fields['phone'].required} />
			<ContactInput type={fields['company'].type} error={fields['company'].error} name="company"  onChange={handleChange} value={fields['company'].value || ''} labelText="Company" required={fields['company'].required} />
			<ContactInput type={fields['country'].type} error={fields['country'].error} name="country"  onChange={handleChange} value={fields['country'].value || ''} labelText="Country" required={fields['country'].required} />
			<div className={s.inputWrapper}>
				<ContactInput type={fields['industry'].type} error={fields['industry'].error} name="industry" labelText="Industry" onChange={handleChange} value={fields['industry'].value || ''} required={fields['industry'].required}/>
				<ContactInput type={fields['companysize'].type} error={fields['companysize'].error} name="companysize" onChange={handleChange} value={fields['companysize'].value || 0} labelText="Company size" required={fields['companysize'].required} />
			</div>
			<ContactTextarea name="description" onChange={handleChange} value={fields['description'].value || ''} labelText="What can you tell us about your scheduling and/or booking requirements?" maxlength="255" required={fields['description'].required}  />
			<label className={s.checkboxLabelWrapper}>
				<Checkbox type={fields['newsletter'].type} error={fields['newsletter'].error} value={fields['newsletter'].value} name="newsletter" onClick={handleClick} checked={fields['newsletter'].checked} required={fields['newsletter'].required} />
				<span className={s.checkboxLabel}>Yes, I would like to receive marketing communications regarding Booker25. I can unsubscribe at any time.</span>
			</label>
			<p className={s.termsconditions}>
				By registering, you agree to the processing of your personal data by Gen25 as described in the <a target="_blank" href="https://www.gen25.com/privacy/">Privacy Statement</a>.
			</p>
		</form>
	)
}

export default Form;
